(function () {
  "use strict";

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.getElementById("MobileMenuToggle");
  var mobileNav = document.getElementById("MobileNav");
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", function () {
      var open = mobileNav.classList.toggle("is-open");
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.getElementById("CartDrawer");
  var cartOverlay = document.getElementById("CartOverlay");
  var cartTrigger = document.getElementById("CartTrigger");
  var cartClose = document.getElementById("CartClose");

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add("is-open");
    cartOverlay.classList.add("is-open");
    cartDrawer.setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    cartOverlay.classList.remove("is-open");
    cartDrawer.setAttribute("aria-hidden", "true");
  }
  if (cartTrigger) cartTrigger.addEventListener("click", openCart);
  if (cartClose) cartClose.addEventListener("click", closeCart);
  if (cartOverlay) cartOverlay.addEventListener("click", closeCart);

  /* ---------------- Countdown timers ---------------- */
  function pad(n) {
    return String(Math.max(0, n)).padStart(2, "0");
  }

  document.querySelectorAll("[data-countdown]").forEach(function (el) {
    var hours = parseFloat(el.getAttribute("data-hours")) || 18;
    var storageKey = "nbs_deal_target";
    var target = Number(sessionStorage.getItem(storageKey));
    if (!target || target < Date.now()) {
      target = Date.now() + hours * 3600 * 1000;
      sessionStorage.setItem(storageKey, String(target));
    }

    var hEl = el.querySelector("[data-h]");
    var mEl = el.querySelector("[data-m]");
    var sEl = el.querySelector("[data-s]");

    function tick() {
      var diff = Math.max(0, target - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------------- Quick add to cart (AJAX) ---------------- */
  function updateCartCount(count) {
    var badge = document.getElementById("CartCount");
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = "flex";
    } else {
      badge.remove();
    }
  }

  function refreshDrawer() {
    return fetch("/?section_id=cart-drawer")
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newDrawer = doc.getElementById("CartDrawer");
        if (newDrawer && cartDrawer) {
          // Swap the whole drawer's inner content (shipping bar, lines, footer)
          // so every part reflects the fresh cart state, while keeping the
          // drawer element itself (and its open/closed state) intact.
          cartDrawer.innerHTML = newDrawer.innerHTML;
          // Re-wire the close button, since it was just replaced.
          var newClose = document.getElementById("CartClose");
          if (newClose) newClose.addEventListener("click", closeCart);
        }
      });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    btn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Add to cart failed");
        return fetch("/cart.js");
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        openCart();
        return refreshDrawer();
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        btn.disabled = false;
      });
  });

  /* ---------------- Remove item from cart drawer (AJAX) ---------------- */
  document.addEventListener("click", function (e) {
    var removeBtn = e.target.closest("[data-remove-line]");
    if (!removeBtn) return;
    e.preventDefault();

    var line = removeBtn.getAttribute("data-remove-line");
    if (!line) return;

    removeBtn.disabled = true;

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: 0 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Remove from cart failed");
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawer();
      })
      .catch(function (err) {
        console.error(err);
        removeBtn.disabled = false;
      });
  });
})();

// ---------- Collection pills horizontal scroll ----------
(function () {
  var track = document.getElementById("CollectionPills");
  var prevBtn = document.querySelector(".pill-scroll-btn--prev");
  var nextBtn = document.querySelector(".pill-scroll-btn--next");
  if (!track || !prevBtn || !nextBtn) return;

  var SCROLL_AMOUNT = 220;

  prevBtn.addEventListener("click", function () {
    track.scrollBy({ left: -SCROLL_AMOUNT, behavior: "smooth" });
  });
  nextBtn.addEventListener("click", function () {
    track.scrollBy({ left: SCROLL_AMOUNT, behavior: "smooth" });
  });
})();

// ---------- Sticky header (JS-driven fixed positioning) ----------
(function () {
  var sentinel = document.getElementById("HeaderSentinel");
  var wrap = document.getElementById("StickyHeaderGroup");
  var spacer = document.getElementById("HeaderSpacer");
  if (!sentinel || !wrap || !spacer) return;

  function pin() {
    if (wrap.classList.contains("is-pinned")) return;
    wrap.classList.add("is-pinned");
    spacer.classList.add("is-active");
    spacer.style.height = wrap.offsetHeight + "px";
  }

  function unpin() {
    if (!wrap.classList.contains("is-pinned")) return;
    wrap.classList.remove("is-pinned");
    spacer.classList.remove("is-active");
    spacer.style.height = "0px";
  }

  function checkScroll() {
    var rect = sentinel.getBoundingClientRect();
    if (rect.top < 0) {
      pin();
    } else {
      unpin();
    }
  }

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.boundingClientRect.top < 0) {
            pin();
          } else {
            unpin();
          }
        });
      },
      { threshold: [0] }
    );
    observer.observe(sentinel);
  } else {
    window.addEventListener("scroll", checkScroll);
    checkScroll();
  }

  // Keep the spacer height accurate if the header's height changes
  // (e.g. window resized, search bar wraps to a new line).
  window.addEventListener("resize", function () {
    if (!wrap.classList.contains("is-pinned")) return;
    spacer.style.height = wrap.offsetHeight + "px";
  });
})();

// ---------- Theme switcher (Light / Dark / Sunset) ----------
(function () {
  var trigger = document.getElementById("ThemeSwitcherTrigger");
  var menu = document.getElementById("ThemeSwitcherMenu");
  if (!trigger || !menu) return;

  var options = Array.prototype.slice.call(menu.querySelectorAll("[data-theme-option]"));
  var STORAGE_KEY = "site-theme";

  function applyTheme(theme) {
    if (theme === "dark" || theme === "sunset") {
      document.documentElement.setAttribute("data-theme", theme);
    } else {
      document.documentElement.removeAttribute("data-theme");
      theme = "light";
    }
    options.forEach(function (opt) {
      opt.classList.toggle("is-active", opt.getAttribute("data-theme-option") === theme);
    });
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {}
  }

  function currentTheme() {
    var saved = null;
    try {
      saved = localStorage.getItem(STORAGE_KEY);
    } catch (e) {}
    return saved === "dark" || saved === "sunset" ? saved : "light";
  }

  function positionMenu() {
    var stickyGroup = document.getElementById("StickyHeaderGroup");
    var anchorBottom = stickyGroup ? stickyGroup.getBoundingClientRect().bottom : trigger.getBoundingClientRect().bottom;
    var triggerRect = trigger.getBoundingClientRect();
    menu.style.top = anchorBottom + 8 + "px";
    menu.style.right = (window.innerWidth - triggerRect.right) + "px";
  }

  function openMenu() {
    positionMenu();
    menu.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");
  }

  function closeMenu() {
    menu.classList.remove("is-open");
    trigger.setAttribute("aria-expanded", "false");
  }

  window.addEventListener("scroll", function () {
    if (menu.classList.contains("is-open")) positionMenu();
  });
  window.addEventListener("resize", function () {
    if (menu.classList.contains("is-open")) positionMenu();
  });

  // Reflect whatever theme the early inline <head> script already applied.
  applyTheme(currentTheme());

  trigger.addEventListener("click", function (e) {
    e.stopPropagation();
    if (menu.classList.contains("is-open")) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  options.forEach(function (opt) {
    opt.addEventListener("click", function () {
      applyTheme(opt.getAttribute("data-theme-option"));
      closeMenu();
    });
  });

  document.addEventListener("click", function (e) {
    if (!menu.contains(e.target) && e.target !== trigger) {
      closeMenu();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMenu();
  });
})();
